var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress-fill",style:({
      width: `${_vm.percentage * 100}%`,
      background: _vm.fillColor,
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }